import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  heromain: {
    position: "relative",
    background: "linear-gradient(180deg, #00351A 0%, #1B1B1B 100%)",
    backdropFilter: "blur(138.4px)",
    "& h1": {
      fontSize: "48px",
      color: "white",
      maxWidth: "631px",
      "@media (max-width: 430px)": {
        fontSize: "32px",
        textAlign: "center"
      }
    }
  },
  // heroorig: {
  //   position: "relative"
  // },
  blurbcg: {
    width: "100%",
    height: "900px",
    borderRadius: "50%",
    background: "rgba(65, 112, 88, 1)",
    filter: "blur(138.4px)",
    position: "absolute",
    top: "356px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: -1 
  },
  tandc: {
    padding: "10px 24px",
    borderRadius: "90px",
    border: "2px solid #FFF",
    maxWidth: "415px",
    fontSize: "18px",
    color: "#FFF",
    fontWeight: "500",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)"
  },
  herocont: {
    maxWidth: "1420px",
    position: "relative",
    margin: "auto",
  },
  heromargin: {
    marginInline: "58px",
    paddingBottom: "80px",
    "@media (max-width: 430px)": {
      marginInline: "20px",
      paddingBottom: "80px",
    }
  },
  heroitems: {
    display: "flex",
    justifyContent: "space-between",
    gap: "40px",
    alignItems: "center",
    paddingBlock: "78.33px 67px",
    "& > *": {
      flex: 1
    },
    "& h4": {
      color: "rgba(255, 255, 255, 1)",
      lineHeight: "32px",
      marginBlock: "0px 16px",
      maxWidth: "554px"
    },
    "@media (max-width: 850px)": {
      flexDirection: "column",
      gap: "10px",
      // marginBlock: "20px",
      textAlign: "center"
    }
  },
  heroimgs: {
    display: "flex",
    justifyContent: "center",
    gap: "12.2px",
    "& img": {
      maxWidth: "215px",
      "@media (max-width: 430px)": {
        maxWidth: "120px"
      }
    },
    "& a": {
      display: "inline-block",
      textDecoration: "none",
      transition: "opacity 0.3s ease",
      "&:hover": {
        opacity: 0.8
      }
    },
    "@media (max-width: 570px)": {
      // flexDirection: "column",
      justifyContent: "center"
    }
  },
  // heroimg: {
  //   "& img": {
  //     width: "100%"
  //   }
  // },
  // heroContainer: {
  //   display: "flex",
  //   // alignItems: "stretch",
  //   // width: "100%",
  //   width: "100%",
  //   "& img": {
  //     width: "100%",
  //     height: "635px"
  //   },
  // },
  itembackground: {
    background: "#001E0F",
    padding: "37px",
    borderRadius: "16px",
    marginBlock: "80px",
    "@media (max-width: 850px)": {
      marginBlock: "20px",
      padding: "16px"
    },
  },
  secondfinancesection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    "@media (max-width: 850px)": {
      flexDirection: "column",
      textAlign: "center"
    },
    "& img": {
      maxWidth: "100%",
      height: "auto"
    }
  },
  forcardinal: {
    flex: "3"
  },
  principle: {
    flex: "2",
  },
  heroimgMain: {
    width: "100%",
    "& img": {
      maxWidth: "100%",
      height: "auto"
    },
    "@media (max-width: 550px)": {
      display: "none"
    },
  },
  heroimgMobile: {
    width: "100%"
  },
  secondsection: {
    maxWidth: "628px",
    // marginBlock: "108.44px 64px",
    "& h2": {
      color: "rgba(255, 255, 255, 1)",
      marginBlock: "0px 32px"
    },
    "& h4": {
      color: "rgba(255, 255, 255, 1)",
      marginBlock: "0px",
      lineHeight: "28px"
    },
  },
  appsection: {
    maxWidth: "554px",
    margin: "auto",
    textAlign: "center",
    "& h4": {
      color: "#FFF",
      fontWeight: "700",
      marginBlock: "0px 12px"
    }
  },
  feature: {
    width: "100%",
    marginBlock: "0px 24px",
    "& h3": {
      color: "rgba(255, 255, 255, 1)",
      marginBlock: "0px 12px"
    },
    "& p": {
      color: "rgba(255, 255, 255, 1)",
      marginBlock: "0px",
      lineHeight: "140%",
      fontSize: "20px !important",
      "@media (max-width: 550px)": {
        textAlign: "center",
        fontSize: "16px !important",
        lineHeight: "32px"
      },
    },
  }
}));
